import api from '../baseApi.js'
import { byName, unwrap } from '../helpers.js'
import { normalizeAcademicYearData } from '../../utils/academicYear.js'

const normalizeFeeParams = (params) => normalizeAcademicYearData(params || {})
const normalizeFeeBody = (body) => normalizeAcademicYearData(body || {})

export const feesApi = {
  getStructures: () =>
    api.get('/fees/structures')
      .then(unwrap)
      .then((data) => byName(normalizeAcademicYearData(data?.structures ?? data ?? []))),
  createStructure: (data) =>
    api.post('/fees/structures', normalizeFeeBody(data)).then(unwrap).then((result) => normalizeAcademicYearData(result?.structure ?? result)),
  updateStructure: (id, data) =>
    api.put(`/fees/structures/${id}`, normalizeFeeBody(data)).then(unwrap).then((result) => normalizeAcademicYearData(result?.structure ?? result)),
  deleteStructure: (id) => api.delete(`/fees/structures/${id}`).then(unwrap),

  getAccounts: (params) =>
    api.get('/fees/accounts', { params: normalizeFeeParams(params) }).then(unwrap).then((data) => normalizeAcademicYearData(data?.accounts ?? data ?? [])),
  generateAccounts: (data) => api.post('/fees/accounts/generate', normalizeFeeBody(data)).then(unwrap).then(normalizeAcademicYearData),
  revertAccounts: (data) => api.post('/fees/accounts/revert', normalizeFeeBody(data)).then(unwrap).then(normalizeAcademicYearData),
  getStudentAccount: (studentId) =>
    api.get(`/fees/accounts/student/${studentId}`).then(unwrap).then((data) => normalizeAcademicYearData(data?.accounts ?? data)),
  getInstallments: (accountId) =>
    api.get(`/fees/accounts/${accountId}/installments`).then(unwrap).then((data) => normalizeAcademicYearData(data?.account ?? data)),
  getFeeTimeline: (accountId) =>
    api.get(`/fees/accounts/${accountId}/timeline`).then(unwrap).then((data) => normalizeAcademicYearData(data?.events ?? data ?? [])),
  recordPayment: (accountId, data) =>
    api.post(`/fees/accounts/${accountId}/payments`, data).then(unwrap),
  reversePayment: (paymentId, data) =>
    api.post(`/fees/payments/${paymentId}/reverse`, data).then(unwrap),

  getSummary: (params) => api.get('/fees/summary', { params: normalizeFeeParams(params) }).then(unwrap).then(normalizeAcademicYearData),
  getDefaulters: (params) =>
    api.get('/fees/defaulters', { params: normalizeFeeParams(params) }).then(unwrap).then((data) => normalizeAcademicYearData(data?.defaulters ?? data ?? [])),
  sendReminders: (data) => api.post('/fees/reminders', normalizeFeeBody(data)).then(unwrap),
  applyDiscount: (accountId, data) =>
    api.post(`/fees/accounts/${accountId}/discount`, data).then(unwrap),
  reverseDiscount: (accountId, data) =>
    api.post(`/fees/accounts/${accountId}/discount/reverse`, data).then(unwrap),
  bulkApplyDiscount: ({ actionToken, ...data }) =>
    api.post('/fees/accounts/bulk-discount', normalizeFeeBody(data), {
      headers: actionToken ? { 'x-action-token': actionToken } : undefined,
    }).then(unwrap).then(normalizeAcademicYearData),
  getReceipt: (paymentId) => api.get(`/fees/payments/${paymentId}/receipt`).then(unwrap).then(normalizeAcademicYearData),

  getAdjustments: (accountId) =>
    api.get(`/fees/accounts/${accountId}/adjustments`).then(unwrap).then((data) => data?.adjustments ?? data ?? []),
  reverseAdjustment: (accountId, adjustmentId) =>
    api.post(`/fees/accounts/${accountId}/adjustments/${adjustmentId}/reverse`).then(unwrap),
  sendReminderToAccount: (accountId, data) =>
    api.post(`/fees/accounts/${accountId}/remind`, data).then(unwrap),
  exportDefaulters: (params, format = 'csv') =>
    api.get('/fees/export/defaulters', { params: normalizeFeeParams(params), responseType: format === 'pdf' ? 'text' : 'blob' }),
  exportAccounts: (params, format = 'csv') =>
    api.get('/fees/export/accounts', { params: normalizeFeeParams(params), responseType: format === 'pdf' ? 'text' : 'blob' }),
}
